import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from '@angular/common/http'
import * as jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import * as moment from 'moment'

import { AppService } from "src/app/server/app.service"
import { Invoice, InvoiceItem } from "../pages/loadplan/obj.model";
import { environment } from '../../environments/environment'


declare var $: any
moment.locale('pt-br')

@Injectable()
export class ExportService {

    invoicePrint: Invoice = new Invoice()
    invoicePrintItems: InvoiceItem[] = []
    routerApi = 'invoices'
    objDoc: any[] = []

    constructor(
        private http: HttpClient,
        private appService: AppService
    ) { }

    getInvoice(invoiceid: string): Observable<any> {
        return this.http.get<any>(`${environment.api}/${this.appService.session.groupid}/${this.routerApi}/${invoiceid}/print`)
    }

    getDoc(docnum: string): Observable<any> {
        return this.http.get<any>(`${environment.api}/${this.appService.session.groupid}/${this.routerApi}/${docnum}/printdoc`)
    }

    printdoc(docnum: any) {
        new Promise<void>(
            (resolve, reject) => {

                this.getDoc(docnum)
                    .subscribe(
                        data => {
                            this.invoicePrint = data[1][0]
                            this.invoicePrintItems = data[2]
                            resolve()
                        }
                    )

            })
            .then((res) => {
                this.printInvoice(this.invoicePrint, true)
            })
            .catch((err) => {
                console.log('deu erro ', err)
            });

    }

    print(invoice: any) {

        new Promise<void>(
            (resolve, reject) => {

                this.getInvoice(invoice.invoiceid)
                    .subscribe(
                        data => {
                            this.invoicePrint = data[1][0]
                            this.invoicePrintItems = data[2]
                            resolve()
                        }
                    )

            })
            .then((res) => {
                this.printInvoice(this.invoicePrint, false)
            })
            .catch((err) => {
                console.log('deu erro ', err)
            });

    }
    printInvoice(invoice: Invoice, open: boolean) {

        let canvaslist: any[] = []
        let seqFile: number = 0
        let fator: number
        let vwFator: number = 209
        this.objDoc = []

        new Promise<void>((resolve, reject) => {

            //HEADER ===================================================
            seqFile = 0
            this.writeFile(seqFile, `   
            <table style="width: 200mm;">
                <tr>
                    <td style="text-align:left;  width: 3mm;  border : none; border-bottom: 1px solid black">                      
                        <img class="img-logo" src="assets/img/logomarca-cdc.png">              
                    </td>            
                    <td style="text-align:left;  width: auto; border : none; border-bottom: 1px solid black;padding-left: 10px;">                    
                        <span>${invoice.branchname}<span></br>
                        <span>CNPJ : ${invoice.branchregistercode}<span></br>
                        <span style="font-size: 10px;">${invoice.branchaddress}</span></br>
                        </br>
                    </td>
                    <td style="text-align:right; width: 50mm; padding-right: 3mm; border : none; border-bottom: 1px solid black ">
                        <span>NOTA Nº <strong>${this.pad(invoice.docnum, 6, '0')}</strong></span>
                    </td>                  
                </tr>
            </table>          
            `)

            //FOOTER ======================================================
            seqFile += 1
            this.writeFile(seqFile, `
            <div class="footer">
                <span style="font-size: 9px; ">Impresso por : ${this.appService.session.username} - ${moment().format('LLLL')}</span>
            </div>
            `)

            //ROWS
            seqFile += 1
            this.writeFile(seqFile, ` 
            <div class="table-container">
                <div class="header-group">
                    DADOS DO CLIENTE
                </div>
                <table>
                <tbody>
                    <tr>
                        <td style="width: 25mm;">PEDIDO : </td>
                        <td>                        
                            ${invoice.orderid} - SÉRIE :  ${invoice.serial} - ROMANEIO :    ${invoice.minutaid}                     
                        </td>
                    </tr>    
                    <tr>
                        <td style="width: 25mm;">CLIENTE : </td>
                        <td>                        
                            ${invoice.name} 
                            
                        </td>
                    </tr>                
                    <tr>
                        <td>CNPJ / CPF: </td>
                        <td>
                           ${invoice.registercode}
                        </td>
                    </tr>
                    <tr>
                        <td>EMAIL : </td>
                        <td>
                            
                        </td>
                    </tr>
                    <tr>
                        <td>CONTATO : </td>
                        <td>
                            
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
            `)

            seqFile += 1
            this.writeFile(seqFile, ` 
                   <div class="table-container">
                       <div class="header-group">
                           LOCAL DE ENTREGA
                       </div>
                       <table>
                           <tbody>
                               <tr>
                                   <td style="width: 25mm;">MOD.ENTREGA:</td>
                                   <td style="width: auto; font-size:14px;">
                                       ${invoice.xmodid}
                                   </td>
                               </tr>
                               <tr>
                                   <td style="width: 25mm;">LOCAL:</td>
                                   <td style="width: auto; font-size:14px;">
                                       ${invoice.xplaceid}
                                   </td>
                               </tr>
                               <tr>
                                   <td style="vertical-align: text-top;">ENDEREÇO:</td>
                                   <td style="vertical-align: text-top; 
                                   overflow-wrap: break-word;
                                   word-wrap: break-word;
                                   hyphens: auto; font-size:14px;">
                                      <strong>${invoice.addressfull}</strong>
                                   </td>
                               </tr>
                               <tr>
                                    <td style="width: 25mm;">PÁGINA DO GUIA:</td>
                                    <td style="width: auto; font-size:14px;">
                                        ${invoice.pagecode}
                                    </td>                              
                              </tr>
                              <tr>
                                <td style="width: 25mm;">PESO TOTAL:</td>
                                <td style="width: auto; font-size:14px;">
                                    ${invoice.grossweight}
                                </td>
                              </tr>
                              <tr>
                              <td style="width: 25mm;">VOLUMES:</td>
                              <td style="width: auto; font-size:14px;">
                                  ${invoice.volumes}
                              </td>
                            </tr>
                             <tr>
                              <td style="width: 25mm;">OBS.EXP:</td>
                              <td style="width: auto; font-size:14px;">
                                  ${invoice.obsexp}
                              </td>
                            </tr>
                             </tr>
                             <tr>
                              <td style="width: 25mm;">OBS.NOT:</td>
                              <td style="width: auto; font-size:14px;">
                                  ${invoice.obsnot}
                              </td>
                            </tr>
                           </tbody>
                       </table>
                   </div>
                   `)


            if (this.invoicePrintItems.length >= 1) {

                seqFile += 1
                this.writeFile(seqFile, `
                        <div class="table-container-part">
                          <div class="header-group">
                              ITENS DA NOTA 
                          </div>      
                        </div> 
                      `)


                let contador: number = 1
                let index: number = 1
                let total: number = 1
                let fileString: string = ''
                total = this.invoicePrintItems.length

                this.invoicePrintItems.forEach(
                    item => {

                        console.log(item)

                        if (item.src) {
                            seqFile += 1
                            this.writeFile(seqFile,
                                `                       
                              <div class="table-row" style="height: 52mm; border: 1px solid gray;">
                                 <table>
                                   <tr>
                                     <td style="width: 500px; vertical-align : top ">
                                        <span style="font-size:16px; "> ${item.shortname}</span> 
                                        <br/>
                                        <br/>
                                        <span style="font-size:26px; font-weight: bold ;">${item.quantity} ${item.quantity > 1 ? 'Caixas' : 'Caixa'}</span>                                   
                                     </td>
                                     <td style="padding-top: 20px">
                                        <img src="${item.src}" width="150" height="150"> 
                                     </td>
                                   </tr>
                                 </table>                              
                              </div>                              
                           `)
                        } else {
                            seqFile += 1
                            this.writeFile(seqFile,
                                `                       
                              <div class="table-row" style="height: 52mm; border: 1px solid gray;">
                                    <span style="font-size:16px; "> ${item.shortname}</span> 
                                    <br/>
                                    <br/>
                                    <span style="font-size:26px; font-weight: bold ;">${item.quantity} ${item.quantity > 1 ? 'Caixas' : 'Caixa'}</span>                                   
                              </div>                              
                           `)
                        }


                    }
                )




            }


            resolve()


        }).then((res) => {


            new Promise<void>((resolve, reject) => {

                this.objDoc.forEach((obj, index) => {

                    html2canvas(obj.document.body, { scale: 2, logging: false })
                        .then(
                            canvas => {

                                canvaslist.push({
                                    file: obj.file,
                                    canvas: canvas
                                })

                                if (index + 1 == this.objDoc.length) {
                                    setTimeout(() => {
                                        resolve()
                                    }, 2000);
                                }
                            })

                })


            }).then((res) => {
                let doc = new jsPDF('portrait', 'mm', 'a4');
                doc.setFontSize(8);
                doc.setProperties({
                    title: `Nota Nº ${invoice.docnum}`,
                    subject: 'Info about PDF',
                    author: 'FlowSystem Soluções Corporativas',
                    keywords: 'Orçamento',
                    creator: 'FLOWAPP by FlowSystem'
                });
                let position = 5;
                let pageNumber = 1

                canvaslist = canvaslist.sort((a, b) => a.file - b.file);

                canvaslist.forEach((obj, index) => {
                    let canvas = obj.canvas
                    let image = canvas.toDataURL('image/jpeg');
                    fator = (vwFator / canvas.width)
                    if ((position + (canvas.height * fator)) >= (292 - (canvaslist[1].canvas.height * fator))) {
                        // INSERE RODAPÉ 
                        doc.addImage(
                            canvaslist[1].canvas.toDataURL('image/jpeg'),
                            'png',
                            5,
                            292 - (canvaslist[1].canvas.height * fator),
                            canvaslist[1].canvas.width * fator,
                            canvaslist[1].canvas.height * fator
                        )
                        doc.text(`Folha: ${pageNumber}`, 190, 292)
                        position = 5
                        doc.addPage()
                        pageNumber += 1
                        //  INSERE HEADER 
                        doc.addImage(
                            canvaslist[0].canvas.toDataURL('image/jpeg'),
                            'png',
                            5,
                            position,
                            canvaslist[0].canvas.width * fator,
                            canvaslist[0].canvas.height * fator
                        )
                        position += (canvaslist[0].canvas.height * fator)
                    }

                    if (index != 1) {
                        //  INSERE ROW 
                        doc.addImage(
                            image,
                            'png',
                            5,
                            position,
                            canvas.width * fator,
                            canvas.height * fator
                        )
                        position += (canvas.height * fator)
                    }

                    if (index == (canvaslist.length - 1)) {
                        doc.addImage(
                            canvaslist[1].canvas.toDataURL('image/jpeg'),
                            'png',
                            5,
                            292 - (canvaslist[1].canvas.height * fator),
                            canvaslist[1].canvas.width * fator,
                            canvaslist[1].canvas.height * fator
                        )
                        doc.text(`Folha: ${pageNumber}`, 190, 292)
                    }

                });

                //doc.output('dataurlnewwindow', `invoice_${invoice.docnum}.pdf`)

                if (open) {
                    //doc.output('dataurlnewwindow', `invoice_${invoice.docnum}.pdf`)
                    const blobUrl = doc.output('bloburl');
                    window.open(blobUrl, '_blank');
                } else {
                    //doc.output('save', `Nota_${invoice.docnum}.pdf`)
                    const blobUrl = doc.output('bloburl');
                    window.open(blobUrl, '_blank');
                }



                //console.log('FIM')
            }).catch((err) => {
                console.log('deu erro canvas', err)
                //this.loading.hide()
            });


        }).catch((err) => {
            console.log('deu erro canvas', err)
            //this.loading.hide()
        });





    }
    writeFile(fileNumber: number, body: any) {

        let strFrameName = ''
        let objFrame: any
        strFrameName = (`printer-${(new Date()).getTime()}`)
        $(`<iframe name='${strFrameName}'>`)
            .css("width", "210mm")
            .css("height", "1mm")
            .css("position", "absolute")
            .css("left", "-9999px")
            .appendTo($("body:first"))

        objFrame = window.frames[strFrameName]

        this.objDoc.push({ file: fileNumber, document: objFrame.document })
        this.objDoc[fileNumber].document.open();
        this.objDoc[fileNumber].document.write(
            `
        <!DOCTYPE HTML>
        <html>
            <head><style> ${this.style} </style></head>
            <body>     
                ${body}
            </body>
        </html>
        `
        )
        this.objDoc[fileNumber].document.close();

    }
    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
    style =
        `      

        @page portrait_A4_page  {
            size:210mm 290mm;
            margin:15mm 15mm 15mm 15mm;
            padding : 0;
            mso-header-margin:15mm;
            mso-footer-margin:15mm;
            mso-paper-source:0;
        }

        div.portrait_A4_page { page:portrait_A4_page; }

        @page landscape_A4_page {
            size:841.9pt 595.3pt;
            mso-page-orientation:landscape;
            margin:72.0pt 72.0pt 72.0pt 72.0pt;
            mso-header-margin:35.45pt;
            mso-footer-margin:35.45pt;
            mso-paper-source:0;
        }

        div.landscape_A4_page { page:landscape_A4_page; }


        @font-face {
            font-family: 'Eras';
            src: url("../../../assets/fonts/eras/erasmedium.ttf");
            font-weight: normal;
            font-style: normal;
        }
        span {
            font-family : 'Eras';
            font-size: 12px;       
        }
        div {
            font-family : 'Eras';
            font-size: 10px;       
        }
        body {    
            margin : 0;        
        }
        .header {
            width : 199mm;        
            border-bottom : 2px solid black;
            padding : 3mm;
            text-align : center;
        }
        .footer {
            width : 199mm;       
            border-top : 2px solid black;
            padding : 3px;
            text-align : left;
        }
        .img-logo {        
            text-align : right;       
            heigth: 30mm;
            width : 58mm;        
        }

        .div-thumb{
            border-top : 1px solid black;
            background-color: white;
            heigth: 65mm;            
            width : 190mm;   
            padding-bottom: 5mm;     
            margin-right: 10mm;
        }
        .img-logo2 {        
            background-color: silver;
            heigth: 50mm;            
            width : 50mm;   
            padding-bottom: 5mm;     
            margin-right: 10mm;
        }
        .img-file {        
            background-color: gray;
            max-heigth: 50mm;
            max-height: 50mm;
            width : 50mm;   
            padding-bottom: 5mm;     
            margin-right: 1mm;
        }
        .caption {
            position: relative;
            font-family : 'Eras';
            font-size: 12px;       
            top: -1mm;
            margin-left: -51mm;
            padding-right : 15mm;
            width : 50mm;   
            color : black;    
          }


        table {
            border-collapse: collapse;
            margin: 0;
            padding: 0;       
        }
        table td {
            border-collapse: collapse;
            border: none;
            margin: 0;
            padding: 0;       
            font-family : 'Eras';
            font-size: 10px; 
        }      
        table.content {
            width: 192mm;
            margin-bottom: 5px;
        }
        table.content td {
            border: 1px solid silver;
            font-family : 'Eras';
            font-size: 10px;     
        }        
        tbody.content-noborder td {
            font-size: 10px;
            border : none;
        }     
        
        .table-row {
            padding-left: 3mm;        
            width: 193mm;
            border-left: 1px solid silver;
            border-right: 1px solid silver;
        }              

        .table-footer {
            border-bottom: 1px solid silver;         
            border-radius: 3px;
            width: 199mm;
        }

        .header-group {
            text-align: center;
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
            background-color: silver; 
            color: black;
            margin: -2mm;
            margin-bottom: 1mm;
            margin-top: -8px;
          }
          
        .table-container {      
            border: 1px solid silver;         
            border-radius: 3px;
            width: 192mm;
            margin-bottom: 5px;
            padding:2mm;
        }

        .table-container-part {      
            border: 1px solid silver; 
            border-bottom : none;
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
            width: 192mm;
            padding:2mm;
            padding-bottom: 0;
            margin-bottom : -3px;
          }


        
    `

}
